"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _flyout = require("../../flyout");
var _focusMode = require("../../focusMode");
var _MenuParentContext = require("../context/MenuParentContext");
var _MenuContainer = require("./MenuContainer");
const warnNoAriaLabel = (0, _lodestarUtils.warnOnce)("An aria-label or aria-labelledby prop is required on the Menu for accessibility.");
const Menu = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    applyMinWidth = false,
    "aria-describedby": ariaDescribedBy,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    children,
    clientId,
    components,
    focusStrategy = "none",
    hasContentBefore = false,
    id,
    isOpen,
    loop = true,
    offset,
    closeOnEscape = true,
    onCloseRequested,
    placement = "bottom-start",
    popperProps,
    portalProps,
    role = "menu",
    targetElement,
    updateKey,
    layout = "compact",
    includeBlanket = false,
    allowClickPropagation = false,
    ...rest
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    if (!ariaLabel && !ariaLabelledby) {
      warnNoAriaLabel();
    }
  }
  const {
    focusMode
  } = (0, _focusMode.useFocusMode)();
  const {
    parent,
    closeMenuRootRequested: parentCloseMenuRootRequested
  } = (0, _MenuParentContext.useMenuParentContext)();
  const memoizedMenuContainerProps = (0, _react.useMemo)(() => {
    return {
      applyMinWidth,
      clientId,
      focusStrategy,
      loop,
      onCloseRequested,
      parent,
      placement,
      includeBlanket
    };
  }, [applyMinWidth, clientId, focusStrategy, loop, onCloseRequested, parent, placement, includeBlanket]);
  return isOpen ? /*#__PURE__*/_react.default.createElement(_MenuParentContext.MenuParentContextProvider, {
    parent: "menu",
    focusMode: focusMode
    // If the current context value of closeMenuRootRequested is the null, that means
    // there are no parent contexts above us i.e. this will be the root context. If
    // that's the case, pass the onCloseRequested of this Menu on to the lower
    // components so submenus can close the entire menu hierarchy.
    ,
    onCloseRequested: parentCloseMenuRootRequested || onCloseRequested,
    hasContentBefore: hasContentBefore,
    layout: layout,
    allowClickPropagation: allowClickPropagation
  }, /*#__PURE__*/_react.default.createElement(_MenuContainer.MenuContainerContext.Provider, {
    value: memoizedMenuContainerProps
  }, /*#__PURE__*/_react.default.createElement(_flyout.ClickAwayListener, {
    onClickAway: onCloseRequested
  }, /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({
    "aria-describedby": ariaDescribedBy,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    arrowColor: undefined,
    clientId: clientId,
    closeOnEscape: closeOnEscape,
    components: {
      FlyoutContainer: _MenuContainer.MenuContainer,
      ...components
    },
    hasArrow: false,
    id: id,
    isOpen: isOpen,
    offset: offset,
    onCloseRequested: onCloseRequested,
    placement: placement,
    popperProps: popperProps,
    portalProps: portalProps,
    role: role,
    targetElement: targetElement,
    updateKey: updateKey,
    ref: ref,
    style: {
      maxHeight: "80vh"
    }
  }, rest), children)))) : null;
});
exports.Menu = Menu;
Menu.displayName = "Menu";
//# sourceMappingURL=Menu.js.map